import debounce from 'lodash/debounce';
import ScrollReveal from './animations/ScrollReveal';
import Header from './components/Header';
import { Sizes } from './types';
import Hero from './components/Hero';
import Projects from './components/Projects';

class Website {
  $body: JQuery<HTMLElement>;
  $links: JQuery<HTMLElement>;
  sizes: Sizes;
  scrollReveal: ScrollReveal | null;
  // lazyVideos: LazyVideos | null;
  header: Header;
  hero: Hero;
  projects: Projects;

  constructor() {
    this.$body = $('body');
    this.sizes = this.getSizes();
    this.scrollReveal = null;
    this.header = new Header();
    this.hero = new Hero();
    this.projects = new Projects();
    this.$links = $('a');

    this.initScrollingLinks();
    this.initObservers();
    this.addEventListeners();
  }

  initScrollingLinks() {
    this.$links.on('click', this.linkClicked.bind(this));
    this.scrollOnPageLoad();
  }

  linkClicked(e: JQuery.ClickEvent) {
    const $cur = $(e.currentTarget);
    const href = $cur.attr('href');
    if (!href) return;
    const hrefArr = href.split('#');
    const { pathname, origin } = window.location;

    // If the href is empty or just a hash, or if it's not a hash but the
    // path doesn't match the current page, do nothing.
    if (
      !href ||
      href === '#' ||
      (!href.startsWith('#') && !href.includes('#')) ||
      (!href.startsWith('#') &&
        hrefArr[0] !== pathname &&
        hrefArr[0] !== origin + pathname)
    ) {
      return;
    }

    const $target = href.startsWith('#') ? $(href) : $(`#${hrefArr[1]}`);
    if ($target.length) {
      e.preventDefault();

      // close header menu
      this.header.closeNav();

      // scroll to target
      const offset = $target.offset();
      if (!offset) return;
      const topOffset = offset.top;

      $('html, body').animate(
        {
          scrollTop: topOffset - 150,
        },
        600,
      );

      // update url hash
      // window.history.pushState(null, '', href);
    }
  }

  scrollOnPageLoad() {
    const { hash } = window.location;
    if (!hash || hash === '#') return;

    const $target = $(hash);
    if (!$target.length) return;

    const offset = $target.offset();
    if (!offset) return;
    const topOffset = offset.top;

    // set initial position to top of page
    window.scrollTo(0, 0);

    setTimeout(() => {
      $('html, body').animate(
        {
          scrollTop: topOffset - 150,
        },
        600,
      );
    }, 500);
  }

  getSizes() {
    const sizes = {
      wWidth: $(window).width()!,
      wHeight: $(window).height()!,
      documentHeight: $(document).height()!,
    };

    this.sizes = sizes;
    return this.sizes;
  }

  initObservers() {
    this.scrollReveal = new ScrollReveal(
      $(
        '[data-visibility]:not(.is-visible), [data-visibility-inside]>*:not(.is-visible)',
      ),
    );
  }

  addEventListeners() {
    $(document).on('mousedown', this.onMouseDown.bind(this));
    $(document).on('keydown', this.onKeyDown.bind(this));

    const debouncedResize = debounce(this.onResize.bind(this), 500);
    $(window).on('resize', debouncedResize);
  }

  onMouseDown() {
    // Let the document know when the mouse is being used
    this.$body.removeClass('is-tab');
  }

  onKeyDown(event: JQuery.KeyDownEvent) {
    // Re-enable focus styling when Tab is pressed
    if (event.key === 'Tab') {
      this.$body.addClass('is-tab');
    }
  }

  onResize() {
    this.getSizes();
    if (this.header.onResize) this.header.onResize(this.sizes);
  }
}

$(function () {
  new Website();
});
